export const type = 'form.password';
